/* src/app/reporting/pages/report-jobs/report-jobs.component.scss */
/*# sourceMappingURL=report-jobs.component.css.map */
